module.exports = __webpack_public_path__ + "img/logo-m2n.55ea0c5b.svg";